import { formTranslations } from "./formTranslations";
import { thankYouTranslations } from "./thankYouTranslations";
import { leadRecoveryTranslations } from "./leadRecoveryTranslations";
import { aboutTranslations } from "./aboutTranslations";
import { internalToolsTranslations } from "./internalToolsTranslations";
import { legalTranslations } from "./legalTranslations";
import { workflowAutomationTranslations } from "./workflowAutomationTranslations";
import { dashboardsReportingTranslations } from "./dashboardsReportingTranslations";
import { spreadsheetRescueTranslations } from "./spreadsheetRescueTranslations";
import { aiAgentsTranslations } from "./aiAgentsTranslations";
import { blogTranslations } from "./blogTranslations";

const base = {
  en: {
    meta: {
      title: "Kranbos | Custom AI for Quotes, Reports & Routine Admin",
      description:
        "Custom AI for businesses that quote, report and answer the same questions all day. Connected to your price sheets, files and software.",
    },
    nav: {
      home: "Home",
      skipToContent: "Skip to content",
      leadRecovery: "Lead Recovery",
      webDesign: "Website Design and Development",
      services: "Services",
      about: "About",
      blog: "Blog",
      contact: "Contact",
      cta: "Book a free 15-min call",
      bookCall: "Book a free call",
    },
    industries: {
      title: "Industries we serve",
      items: [
        "HVAC",
        "Plumbing",
        "Cleaning",
        "Restoration",
        "Property managers",
        "Moving",
        "Med spas",
      ],
    },
    otherServices: {
      title: "Need more than lead recovery?",
      learnMore: "Learn more",
      svc1Title: "Internal Tools",
      svc1Text: "Custom web apps and tools built specifically for your operations.",
      svc2Title: "Workflow Automation",
      svc2Text: "Connecting your existing software to eliminate manual data entry.",
      svc3Title: "Dashboards & Reporting",
      svc3Text: "Get a clear view of your business health with live data visualization.",
      svc4Title: "Spreadsheet Rescue",
      svc4Text: "Turning broken, slow spreadsheets into fast, reliable systems.",
    },
    call: {
      prompt: "Prefer to talk? Call",
      footerLabel: "Call us",
    },
    caseStudies: {
      metaTitle: "Case Studies | Kranbos Custom AI Automation",
      metaDescription: "Real Kranbos client projects: the manual work, the tools we connected, and the measured before-and-after results.",
      eyebrow: "Results",
      title: "Case studies from real client projects",
      titleAccent: "real client projects",
      subtitle: "What the client did by hand, what we built, and what changed.",
      readMore: "Read the case study",
      back: "All case studies",
      problem: "The problem",
      toolsUsed: "Tools connected",
      before: "Before",
      after: "After",
      results: "Results",
      viewAll: "See all case studies",
    },
    footer: {
      tagline:
        "Custom AI automation for businesses that quote, report and answer the same questions all day.",
      copyrightPrefix: "©",
      copyrightSuffix: "Kranbos. All rights reserved.",
      navigation: "Navigation",
      solutions: "Solutions",
      industries: "Industries",
      trust: "Trust & Security",
      privacyPolicy: "Privacy Policy",
      terms: "Terms & Conditions",
      insuredBy: "Insured & Covered by",
      soc2Infra: "Built on SOC 2 Type II-audited infrastructure",
      soc2InfraNote: "Our infrastructure vendors hold SOC 2 Type II reports. Kranbos itself is not SOC 2 audited.",
      trustBadges: "Security and compliance",
      theme: "Theme",
      themeSystem: "System",
      themeLight: "Light",
      themeDark: "Dark",
    },
    whatsapp: {
      label: "Chat with us on WhatsApp",
      message: "Hi Kranbos! I'd like to learn more about your services.",
    },
    underConstruction: {
      title: "Under construction",
      text: "This page is coming soon. Check back shortly!",
      backHome: "Back to Home",
    },
  },
  es: {
    meta: {
      title: "Kranbos | IA a Medida para Cotizaciones, Reportes y Admin",
      description:
        "IA a medida para negocios que cotizan, reportan y responden las mismas preguntas todo el día. Conectada a tus precios, archivos y software.",
    },
    nav: {
      home: "Inicio",
      skipToContent: "Saltar al contenido",
      leadRecovery: "Recuperación de Leads",
      webDesign: "Diseño y Desarrollo Web",
      services: "Servicios",
      about: "Nosotros",
      blog: "Blog",
      contact: "Contacto",
      cta: "Agenda una llamada gratis de 15 min",
      bookCall: "Agenda una llamada gratis",
    },
    industries: {
      title: "Industrias que atendemos",
      items: [
        "HVAC",
        "Plomería",
        "Limpieza",
        "Restauración",
        "Administradores de propiedades",
        "Mudanzas",
        "Med spas",
      ],
    },
    otherServices: {
      title: "¿Necesitas más que recuperación de leads?",
      learnMore: "Saber más",
      svc1Title: "Herramientas Internas",
      svc1Text: "Aplicaciones web y herramientas a medida para tus operaciones.",
      svc2Title: "Automatización de Flujos",
      svc2Text: "Conectamos tu software existente para eliminar la carga manual de datos.",
      svc3Title: "Paneles y Reportes",
      svc3Text: "Obtén una vista clara de la salud de tu negocio con visualización de datos en vivo.",
      svc4Title: "Rescate de Hojas de Cálculo",
      svc4Text: "Convertimos hojas de cálculo rotas y lentas en sistemas rápidos y confiables.",
    },
    call: {
      prompt: "¿Prefieres hablar? Llama al",
      footerLabel: "Llámanos",
    },
    caseStudies: {
      metaTitle: "Casos de Éxito | Automatización con IA a Medida de Kranbos",
      metaDescription: "Proyectos reales de clientes de Kranbos: el trabajo manual, las herramientas conectadas y los resultados medidos antes y después.",
      eyebrow: "Resultados",
      title: "Casos de proyectos reales con clientes",
      titleAccent: "proyectos reales",
      subtitle: "Lo que el cliente hacía a mano, lo que construimos y lo que cambió.",
      readMore: "Leer el caso",
      back: "Todos los casos",
      problem: "El problema",
      toolsUsed: "Herramientas conectadas",
      before: "Antes",
      after: "Después",
      results: "Resultados",
      viewAll: "Ver todos los casos",
    },
    footer: {
      tagline:
        "Automatización con IA a medida para negocios que cotizan, reportan y responden las mismas preguntas todo el día.",
      copyrightPrefix: "©",
      copyrightSuffix: "Kranbos. Todos los derechos reservados.",
      navigation: "Navegación",
      solutions: "Soluciones",
      industries: "Industrias",
      trust: "Confianza y Seguridad",
      privacyPolicy: "Política de Privacidad",
      terms: "Términos y Condiciones",
      insuredBy: "Asegurado y cubierto por",
      soc2Infra: "Sobre infraestructura con auditoría SOC 2 Tipo II",
      soc2InfraNote: "Nuestros proveedores de infraestructura tienen informes SOC 2 Tipo II. Kranbos no tiene una auditoría SOC 2 propia.",
      trustBadges: "Seguridad y cumplimiento",
      theme: "Tema",
      themeSystem: "Sistema",
      themeLight: "Claro",
      themeDark: "Oscuro",
    },
    whatsapp: {
      label: "Escríbenos por WhatsApp",
      message: "¡Hola Kranbos! Me gustaría saber más sobre sus servicios.",
    },
    underConstruction: {
      title: "En construcción",
      text: "Esta página estará disponible pronto. ¡Vuelve en breve!",
      backHome: "Volver al Inicio",
    },
  },
};

export const translations = {
  en: {
    ...base.en,
    ...formTranslations.en,
    ...thankYouTranslations.en,
    ...leadRecoveryTranslations.en,
    ...aboutTranslations.en,
    ...internalToolsTranslations.en,
    ...legalTranslations.en,
    ...workflowAutomationTranslations.en,
    ...dashboardsReportingTranslations.en,
    ...spreadsheetRescueTranslations.en,
    ...aiAgentsTranslations.en,
    ...blogTranslations.en,
  },
  es: {
    ...base.es,
    ...formTranslations.es,
    ...thankYouTranslations.es,
    ...leadRecoveryTranslations.es,
    ...aboutTranslations.es,
    ...internalToolsTranslations.es,
    ...legalTranslations.es,
    ...workflowAutomationTranslations.es,
    ...dashboardsReportingTranslations.es,
    ...spreadsheetRescueTranslations.es,
    ...aiAgentsTranslations.es,
    ...blogTranslations.es,
  },
};

/** Supported UI languages. */
export type Language = keyof typeof translations;

/** Shape of a single locale's translation tree. */
export type Translation = (typeof translations)[Language];
